export class Status {
    public static values = [
        "ACTIVE",
        "INACTIVE"
    ];
}